const isDesktopRolGuard = (to, from, next) => {
  const tipoUsuario = localStorage.getItem("tipo usuario");

  const rolesPermitidos = [
    "User Tester",
    "Super User",
    "Jefe de Dependencia",
    "Oficial Sumariante",
    "Jefe de Sumario",
    "UsuarioDependencia",
    "Control de Gestion",
    "Dirección de Información para el Delito D-2",
    "Dpto. Asuntos Judiciales D-5",
    "Dpto. Planeamiento",
    "Juez",
    "Ayudante de Juez",
    "Dpto.Criminalistica",
    "Lab. Informatico Forense",
    "Administrativo",
    "Ayudante Fiscal",
    "Fiscal",
    "Fiscal General",
    "Policia Investigador",
    "Supervisor",
    "UsuarioDepartamental",
    "Deposito Judicial",
  ];

  if (rolesPermitidos.includes(tipoUsuario)) {
    next();
  } else {
    tipoUsuario === "Calabocero" ? next("/calabozo") : next("/acceso-denegado");
  }
};

export default isDesktopRolGuard;
